 /**
  * @desc  存储可视区域高度的信息
  * @param {Object} wait - 页面初次加载 和 刷新页面时更新
  * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)
  */
  export const SET_VISIBLE_HEIGHT = (state, height) => {
    state.visibleHeight = height
  }
  /**
   * @desc  存储可视区域宽度的信息
   * @param {Object} wait - 页面初次加载 和 刷新页面时更新
   * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)
   */
  export const SET_VISIBLE_WIDTH = (state, width) => {
    state.visibleWidth = width
  }
  /**
   * @desc  存储页面顶部检索栏高度的信息
   * @param {Object} wait - 页面初次加载 和 刷新页面时更新
   * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)
   */
  export const SET_SEARCH_HEIGHT = (state, height) => {
    state.searchHeight = height
  }
  /**
   * @desc  存储页面底部分页栏高度的信息
   * @param {Object} wait - 页面初次加载 和 刷新页面时更新
   * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)pagination
   */
  export const SET_PAGINATION_HEIGHT = (state, height) => {
    state.paginationHeight = height
  }
  /**
   * @desc  存储页面表格高度信息
   * @param {Object} wait - 页面初次加载 和 刷新页面时更新
   * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)pagination
   */
  export const SET_TABLE_HEIGHT = (state, height) => {
    state.tableHeight = height
  }
  /**
  * @desc  全局loadding加载
  * @param {Object} wait - load
  */
   export const showloading = (state, load) => {
     state.loading = load
   }


// WEBPACK FOOTER //
// ./src/store/mutations.js